import News from './components/News';
export default News;